var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableNotSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2C1 1.44772 1.44772 1 2 1H43V45H2C1.44772 45 1 44.5523 1 44V2Z",
    stroke: "#00857C",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7378_51322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2857 15.1387H12.7143C12.3192 15.1387 12 15.4579 12 15.853V30.1387C12 30.5338 12.3192 30.853 12.7143 30.853H31.2857C31.6808 30.853 32 30.5338 32 30.1387V15.853C32 15.4579 31.6808 15.1387 31.2857 15.1387ZM30.3929 19.7815H25.6607V16.7458H30.3929V19.7815ZM30.3929 24.7815H25.6607V21.2101H30.3929V24.7815ZM19.7679 21.2101H24.2321V24.7815H19.7679V21.2101ZM24.2321 19.7815H19.7679V16.7458H24.2321V19.7815ZM13.6071 21.2101H18.3393V24.7815H13.6071V21.2101ZM13.6071 16.7458H18.3393V19.7815H13.6071V16.7458ZM13.6071 26.2101H18.3393V29.2458H13.6071V26.2101ZM19.7679 26.2101H24.2321V29.2458H19.7679V26.2101ZM30.3929 29.2458H25.6607V26.2101H30.3929V29.2458Z",
    fill: "#00857C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7378_51322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableNotSelected);
export default __webpack_public_path__ + "static/media/TableNotSelected.10ae892ca2c541d745957b65f81d132d.svg";
export { ForwardRef as ReactComponent };